document.addEventListener('DOMContentLoaded', () => {
    const video = document.querySelector('.js-fv-video');
    const MIN_WAIT = 1000; // 最低待機時間（ms）
    const SCROLL_UNLOCK_DELAY = 3000; // loaded後の待機（ms）

    let isMinTimePassed = false;
    let isVideoReady = false;
    let isLoaded = false;

    // 初期状態でスクロール禁止
    document.body.classList.add('is-scroll-locked');

    const unlockScroll = () => {
        document.body.classList.remove('is-scroll-locked');
    };

    const trySetLoaded = () => {
        if (isMinTimePassed && isVideoReady) {
            isLoaded = true;
            document.body.classList.add('loaded');
            // スクロール解除
            setTimeout(unlockScroll, SCROLL_UNLOCK_DELAY);
        }
    };

    // ① 最低1秒待つ
    setTimeout(() => {
        isMinTimePassed = true;
        trySetLoaded();
    }, MIN_WAIT);

    // ② video がある場合
    if (video) {
        // すでに再生可能ならOK
        if (video.readyState >= 3) {
            isVideoReady = true;
            trySetLoaded();
        }

        // autoplay 試行（成功・失敗どちらでもOK）
        video.play()
            .then(() => {
                isVideoReady = true;
                trySetLoaded();
            })
            .catch(() => {
                isVideoReady = true;
                trySetLoaded();
            });
    } else {
        // ③ video が無い場合は即OK扱い
        isVideoReady = true;
        trySetLoaded();
    }
});
